import { MeetingService } from './src/services/meeting.service';
export const meetingService = new MeetingService();
export default meetingService;
